import {
  GET_TOUR_PROGRESS_REQUEST,
  GET_TOUR_PROGRESS_SUCCESS,
  GET_TOUR_PROGRESS_FAIL,
  UPDATE_TOUR_PROGRESS_REQUEST,
  UPDATE_TOUR_PROGRESS_SUCCESS,
  UPDATE_TOUR_PROGRESS_FAIL,
  GET_TOUR_ONBOARDING_STATUS_REQUEST,
  GET_TOUR_ONBOARDING_STATUS_SUCCESS,
  GET_TOUR_ONBOARDING_STATUS_FAIL,
  TOUR_ONBOARDING_STATUS_RESET,
} from "../constants/guidedTourConstants";
import { getRequest, postRequest, patchRequest } from "../../Apis/apiWrapper";
import { guidedTourEndpoints } from "../../utils/constants/httpConstants";
import { LOGIN_PATH } from "../../utils/constants/routes";

export const getTourProgressAction = (navigate) => async (dispatch) => {
  try {
    dispatch({ type: GET_TOUR_PROGRESS_REQUEST });
    const response = await getRequest(navigate, guidedTourEndpoints.getTourProgress);
    dispatch({ type: GET_TOUR_PROGRESS_SUCCESS, payload: response?.data });
    return { success: true, data: response?.data };
  } catch (err) {
    if (err?.status === 401) {
      navigate(LOGIN_PATH);
    }
    dispatch({ type: GET_TOUR_PROGRESS_FAIL, payload: err?.data });
    return { success: false };
  }
};

export const updateTourProgressAction =
  (navigate, { tour_id, version, completed_step }) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPDATE_TOUR_PROGRESS_REQUEST });
      const response = await postRequest(navigate, guidedTourEndpoints.updateTourProgress, {
        tour_id,
        version,
        completed_step,
      });
      dispatch({ type: UPDATE_TOUR_PROGRESS_SUCCESS, payload: response?.data });
    } catch (err) {
      if (err?.status === 401) {
        navigate(LOGIN_PATH);
      }
      dispatch({ type: UPDATE_TOUR_PROGRESS_FAIL, payload: err?.data });
    }
  };

export const getTourOnboardingStatusAction = (navigate) => async (dispatch) => {
  try {
    dispatch({ type: GET_TOUR_ONBOARDING_STATUS_REQUEST });
    const response = await getRequest(navigate, guidedTourEndpoints.getTourOnboardingStatus);
    dispatch({ type: GET_TOUR_ONBOARDING_STATUS_SUCCESS, payload: response?.data?.data });
    return { success: true, data: response?.data?.data };
  } catch (err) {
    if (err?.status === 401) {
      navigate(LOGIN_PATH);
    }
    dispatch({ type: GET_TOUR_ONBOARDING_STATUS_FAIL, payload: err?.data });
    return { success: false };
  }
};

export const markWelcomeModalSeenAction = (navigate) => async () => {
  try {
    await patchRequest(navigate, guidedTourEndpoints.markWelcomeModalSeen);
  } catch (err) {
    if (err?.status === 401) navigate(LOGIN_PATH);
  }
};

export const updateBannerSeenAction = (navigate) => async () => {
  try {
    await patchRequest(navigate, guidedTourEndpoints.updateBannerSeen);
  } catch (err) {
    if (err?.status === 401) navigate(LOGIN_PATH);
  }
};

export const dismissTourBannerAction = (navigate) => async () => {
  try {
    await patchRequest(navigate, guidedTourEndpoints.dismissTourBanner);
  } catch (err) {
    if (err?.status === 401) navigate(LOGIN_PATH);
  }
};

export const resetTourOnboardingStatusAction = () => (dispatch) => {
  dispatch({ type: TOUR_ONBOARDING_STATUS_RESET });
};
